import { Routes } from '@angular/router';
import { unsavedChangesGuard } from './unsaved-changes.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./landing-page/landing-page.component').then(m => m.LandingPageComponent)
  },
  {
    path: 'anleitung',
    loadComponent: () => import('./instructions-page/instructions-page.component').then(m => m.InstructionsPageComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./auth/reset-password-page/reset-password-page.component').then(m => m.ResetPasswordPageComponent)
  },
  {
    path: 'dashboard/:role',
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'admin/collecting-locations',
    loadComponent: () => import('./collecting-location/collecting-locations-page/collecting-locations-page.component')
      .then(m => m.CollectingLocationsPageComponent)
  },
  {
    path: 'admin/streets',
    loadComponent: () => import('./street/streets-page/streets-page.component').then(m => m.StreetsPageComponent)
  },
  {
    path: 'admin/collecting-zones',
    loadComponent: () => import('./collecting-zone/collecting-zones-page/collecting-zones-page.component')
      .then(m => m.CollectingZonesPageComponent)
  },
  {
    path: 'admin/collecting-areas',
    loadComponent: () => import('./collecting-area/collecting-areas-page/collecting-areas-page.component')
      .then(m => m.CollectingAreasPageComponent)
  },
  {
    path: 'admin/engines',
    loadComponent: () => import('./engine/engines-page/engines-page.component').then(m => m.EnginesPageComponent)
  },
  {
    path: 'admin/users',
    loadComponent: () => import('./user/users-page/users-page.component').then(m => m.UsersPageComponent)
  },
  {
    path: 'admin/messages',
    loadComponent: () => import('./admin-message/admin-messages-page.component')
      .then(m => m.AdminMessagesPageComponent)
  },
  {
    path: 'admin/pickup-dates',
    loadComponent: () => import('./pickup-date/pickup-dates-page/pickup-dates-page.component')
      .then(m => m.PickupDatesPageComponent)
  },
  {
    path: 'orders',
    loadComponent: () => import('./order/order-list-page/order-list-page.component')
      .then(m => m.OrderListPageComponent)
  },
  {
    path: 'payments',
    loadComponent: () => import('./order/payment-capture-page/payment-capture-page.component')
      .then(m => m.PaymentCapturePageComponent),
    canDeactivate: [unsavedChangesGuard]
  },
  {
    path: 'pickup-tours',
    loadComponent: () => import('./pickup-tour/pickup-tour-list-page/pickup-tour-list-page.component')
      .then(m => m.PickupTourListPageComponent)
  },
  {
    path: 'pickup-tours/crew-overview',
    loadComponent: () => import('./pickup-tour/crew-overview-page/crew-overview-page.component')
      .then(m => m.CrewOverviewPageComponent)
  },
  {
    path: 'pickup-tours/controlling',
    loadComponent: () => import('./pickup-tour/controlling-tour-list-page/controlling-tour-list-page.component')
      .then(m => m.ControllingTourListPageComponent)
  },
  {
    path: 'pickup-tours/:tourId/collector',
    loadComponent: () => import('./pickup-tour/collector-order-view-page/collector-order-view-page.component')
      .then(m => m.CollectorOrderViewPageComponent),
    canDeactivate: [unsavedChangesGuard]
  },
  {
    // The embedded uMap page (TourMapPageComponent) is switched off for now - everybody gets the app's own live
    // map instead. The component stays in the code base to be re-enabled later by pointing this route at it again.
    path: 'pickup-tours/:tourId/map',
    redirectTo: 'pickup-tours/:tourId/live-map'
  },
  {
    path: 'pickup-tours/:tourId/live-map',
    loadComponent: () => import('./pickup-tour/tour-live-map-page/tour-live-map-page.component')
      .then(m => m.TourLiveMapPageComponent)
  },
  {
    path: 'pickup-tours/:tourId/list',
    loadComponent: () => import('./pickup-tour/tour-list-driver-page/tour-list-driver-page.component')
      .then(m => m.TourListDriverPageComponent)
  },
  {
    path: 'pickup-tours/:tourId/controlling',
    loadComponent: () => import('./pickup-tour/controlling-tour-page/controlling-tour-page.component')
      .then(m => m.ControllingTourPageComponent)
  }
];
